import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Vælg din startplan <br/> Vi klarer det hele, <underline>DU</underline> læner dig tilbage 🚀',
  billing_modes: {
    [BillingMode.InternalInvoicing]: 'Betal senere af salget',
    [BillingMode.Stripe]: '(0)[Betal nu];(1-inf)[Betal nu (spar op til {{discount}})]',
  },
};
